/*@ngInject*/
const DataSetEditorModel = function ($rootScope, $timeout, coreMediator, configurationConstant, dataSetType) {

    var dataSetEditorModel = {};

    this.reset = function (dataSetName) {
        if (!_.isNil(dataSetName)) {
            dataSetEditorModel[dataSetName] = {
                dataSet: null,
                isDraggingDataItemsGroup: false,
                isDraggingDataItems: false,
                isValid: null,
                isValidToSave: null,
                isValidDynamicCriterion: null,
                isValidDynamicCriterionToSave: null,
                isValidDependencies: null,
                isValidDependenciesToSave: null,
                hasUnsavedChanges: false
            };
        } else {
            dataSetEditorModel = {};
        }
    };

    this.buildDataSet = function (dataSetName) {
        this.reset(dataSetName);

        coreMediator.getRemoteDataSetByName(dataSetName).then(function (dataSet) {
            this.updateDataSet(dataSet);
        }.bind(this));
    };

    this.getDataSet = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return model.dataSet;
    };

    this.addDataItem = function (dataSetName, grouping) {
        var model = dataSetEditorModel[dataSetName],
            dataItem = {
                grouping: grouping,
                name: '',
                value: '',
                defaultPrecedence: null
            };
        model.dataSet.items.push(dataItem);

        return dataItem;
    };

    this.removeDataItem = function (dataSetName, dataItem) {
        var model = dataSetEditorModel[dataSetName],
            index = _.findIndex(model.dataSet.items, function (item) {
                return dataItem === item;
            });
        model.dataSet.items.splice(index, 1);
    };

    this.addSourceFieldDependency = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName],
            sourceFieldDependency = {
                formTemplateUniqueName: '',
                fieldName: '',
                key: ''
            };

        model.dataSet.dynamicDataSetDependency.sourceFieldDependencies.push(sourceFieldDependency);

        return sourceFieldDependency;
    };

    this.removeSourceFieldDependency = function (dataSetName, sourceFieldDependency) {
        var model = dataSetEditorModel[dataSetName],
            index = _.findIndex(model.dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (item) {
                return sourceFieldDependency === item;
            });

        model.dataSet.dynamicDataSetDependency.sourceFieldDependencies.splice(index, 1);

        // Property shift over the field values
        _.each(model.dataSet.items, function (dataItem) {
            _.each(dataItem.enhancedDynamicDataItemCriteriaList, function (dynamicDataItemCriteria) {
                _.each(_.range(index + 1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES), function (fieldValueIndex) {
                    dynamicDataItemCriteria['fieldValue' + fieldValueIndex] = dynamicDataItemCriteria['fieldValue' + (fieldValueIndex + 1)];
                });
                // When removing a source field dependency, the last entry will always be null, so make sure to set it.
                dynamicDataItemCriteria['fieldValue' + configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES] = null;
            });
        });
    };

    this.moveDynamicDataItemCriteria = function (dataSetName, dynamicDataItemCriteria, destinationDataItemValue) {
        var model = dataSetEditorModel[dataSetName],
            currentDataItem = null,
            destinationDataItem = null,
            currentDynamicDataItemIndex;

        _.each(model.dataSet.items, function (dataItem) {
            if (dataItem.value === dynamicDataItemCriteria.value) {
                currentDataItem = dataItem;
            } else if (!_.isEmpty(destinationDataItemValue) && dataItem.value === destinationDataItemValue) {
                destinationDataItem = dataItem;
            }
        });

        if (!_.isNil(currentDataItem)) {
            currentDynamicDataItemIndex = _.findIndex(currentDataItem.enhancedDynamicDataItemCriteriaList, function (item) {
                return dynamicDataItemCriteria === item;
            });

            // Remove dynamicDataItemCriteria from current data item
            currentDataItem.enhancedDynamicDataItemCriteriaList.splice(currentDynamicDataItemIndex, 1);
        }

        if (!_.isNil(destinationDataItem)) {
            // Add dynamicDataItemCriteria to destination data item
            destinationDataItem.enhancedDynamicDataItemCriteriaList.push(dynamicDataItemCriteria);
        }

        dynamicDataItemCriteria.value = destinationDataItemValue;
    };

    this.setDraggingDataItemsGroup = function (dataSetName, dragging) {
        var model = dataSetEditorModel[dataSetName];
        model.isDraggingDataItemsGroup = dragging;
    };

    this.setDraggingDataItems = function (dataSetName, dragging) {
        var model = dataSetEditorModel[dataSetName];
        model.isDraggingDataItems = dragging;
    };

    this.isDraggingDataItemsGroup = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return model.isDraggingDataItemsGroup;
    };

    this.isDraggingDataItems = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return model.isDraggingDataItems;
    };

    this.setValid = function (dataSetName, valid) {
        var model = dataSetEditorModel[dataSetName];
        model.isValid = valid;
        model.isValidToSave = valid;
    };

    this.isValid = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return model.isValid;
    };

    this.setValidDynamicCriterion = function (dataSetName, valid) {
        var model = dataSetEditorModel[dataSetName];
        model.isValidDynamicCriterion = valid;
        model.isValidDynamicCriterionToSave = valid;
    };

    this.isValidDynamicCriterion = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return model.isValidDynamicCriterion;
    };

    this.setValidDependencies = function (dataSetName, valid) {
        var model = dataSetEditorModel[dataSetName];
        model.isValidDependencies = valid;
        model.isValidDependenciesToSave = valid;
    };

    this.isValidDependencies = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return model.isValidDependencies;
    };

    this.renameDataSet = function (oldName, newName) {
        if (oldName !== newName) {
            dataSetEditorModel[newName] = dataSetEditorModel[oldName];
            delete dataSetEditorModel[oldName];
        }
    };

    this.setUnsavedChanges = function (dataSetName, hasUnsavedChanges) {
        var model = dataSetEditorModel[dataSetName];
        model.hasUnsavedChanges = hasUnsavedChanges;
    };

    this.hasUnsavedChanges = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return model.hasUnsavedChanges;
    };

    this.isValidToSave = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return _.isNil(model.isValidToSave) || model.isValidToSave;
    };

    this.isValidDynamicCriterionToSave = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return _.isNil(model.isValidDynamicCriterionToSave) || model.isValidDynamicCriterionToSave;
    };

    this.isValidDependenciesToSave = function (dataSetName) {
        var model = dataSetEditorModel[dataSetName];
        return _.isNil(model.isValidDependenciesToSave) || model.isValidDependenciesToSave;
    };

    this.updateDataSet = function (dataSet) {
        var model = {
            dataSet: _.cloneDeep(dataSet),
            isDraggingDataItemsGroup: false,
            isDraggingDataItems: false,
            isValid: null,
            isValidToSave: null,
            isValidDynamicCriterion: null,
            isValidDynamicCriterionToSave: null,
            isValidDependencies: null,
            isValidDependenciesToSave: null,
            hasUnsavedChanges: false
        };

        if ((dataSet.type === dataSetType.CUSTOM || dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT) &&
            _.isNil(dataSet.dynamicDataSetDependency)) {
            model.dataSet.dynamicDataSetDependency = {
                productDependent: false,
                sourceFieldDependencies: []
            };
        }

        dataSetEditorModel[dataSet.name] = model;

        $rootScope.$broadcast(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, dataSet.name);
    };
};

angular.module('ums.configuration')
    .service('dataSetEditorModel', DataSetEditorModel);
